export const FirebaseConfig = {
	"projectId": "top-drive-d7332",
	"appId": "1:393733758580:web:2028f4a3eba1da18aefb21",
	"databaseURL": "https://top-drive-d7332-default-rtdb.firebaseio.com",
	"storageBucket": "top-drive-d7332.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyC_jgAvtISGEj5kF5YXTrHmBt6Fk1LOfd0",
	"authDomain": "top-drive-d7332.firebaseapp.com",
	"messagingSenderId": "393733758580",
	"measurementId": "G-QE2YHK7Z8W"
};